import React, { useEffect, useState } from 'react'
import Astrea from 'svg/logos/nav-astrea.svg'
import Aurum from 'svg/logos/nav-aurum.svg'
import Themis from 'svg/logos/nav-themis.svg'
import { useThemeContext } from 'contexts/themeContext/hooks'

const Logo = () => {
	const [anchor, setAnchor] = useState(false)

	const { theme, page } = useThemeContext()

	useEffect(() => {
		const filterPathname = (value) => {
			return value !== ''
		}

		const pathnameLocationUrl = window.location.pathname
		const pagePath = pathnameLocationUrl.split('/').filter(filterPathname)

		// se o tamanho é 0 significa que esta retornando a página inicial do produto
		// e precisa se comportar como uma ancora para o top da pagina
		if (pagePath.length < 1) return setAnchor(true)
		// caso maior que 1 é uma subpagina, logo deve se tornar um link para o produto
		if (pagePath.length > 1) return setAnchor(false)
		// caso igual a 1 ele pode ser a pagina inicial do produto ou uma subpagina
		if (pagePath.length === 1) {
			switch (pagePath[0]) {
				case 'aurum':
					setAnchor(true)
					break
				case 'astrea':
					setAnchor(true)
					break
				case 'themis-para-departamento-juridico':
					setAnchor(true)
					break
				case 'themis-para-escritorios-de-advocacia':
					setAnchor(true)
					break
				case 'software-themis-para-departamento-juridico':
					setAnchor(true)
					break
				default:
					setAnchor(false)
			}
		}
	}, [])

	const iconLogo = () => {
		if (theme === 'aurum') return <Aurum />
		if (theme === 'astrea') return <Astrea />
		if (theme === 'themis') return <Themis />
		else return <Aurum />
	}

	const classLogo = () => {
		if (theme === 'aurum') return 'logo-aurum'
		if (theme === 'astrea') return 'logo-astrea'
		if (theme === 'themis') return 'logo-themis'
		else return 'logo-aurum'
	}

	const linkLogo = () => {
		if (theme === 'aurum') return '/'
		if (theme === 'astrea') return '/astrea'
		if (theme === 'themis' && page === 'themis-dj')
			return '/themis-para-departamento-juridico'
		if (theme === 'themis' && page === 'themis-ea')
			return '/themis-para-escritorios-de-advocacia'
		else return '/'
	}

	const handleClick = () => {
		window.scrollTo(0, 0)
	}

	const renderLogo = () => {
		if (anchor) {
			return (
				<i className={classLogo()} onClick={() => handleClick()}>
					{iconLogo()}
				</i>
			)
		} else {
			return (
				<a href={linkLogo()} className={classLogo()}>
					{iconLogo()}
				</a>
			)
		}
	}

	return renderLogo()
}

export default Logo
